import { Page } from './Page';
import { isoDate, parseLocal } from '../lib/dates';
import { TodayView } from '../components/today/TodayView';
import { useDateIntent, useNav } from './NavContext';
import { DailyStack } from '../components/notifications/DailyStack';

// Today (Daily dashboard) — the landing view. The selected day is the app's one
// shared anchor (top-bar date picker); creates come from the global New menu. The
// desk + context bands live in TodayView and recompute for the day.
export function TodayPage() {
  const { anchor, setAnchor } = useNav();
  const anchorIso = isoDate(anchor);

  // Land on the day another page handed us (Messages "Arriving → view all"), so
  // the drop-offs match the count that was clicked. The intent carries an ISO
  // string; the shared anchor is a Date.
  useDateIntent('today', (d) => setAnchor(parseLocal(d)));

  return (
    <Page title="Daily" aside={<DailyStack />}>
      <TodayView anchor={anchorIso} />
    </Page>
  );
}
